import { useId, useState } from 'react';
import { KTIcon } from '@/_metronic/helpers';

type AnnouncementAcknowledgementProps = {
  acknowledging: boolean;
  onAcknowledge: () => void;
  /** Quem criou vê a confirmação como o destinatário, mas sem poder marcar nem dar ciência. */
  preview?: boolean;
};

/** Confirmação de leitura do obrigatório: a ciência só libera depois da caixa marcada. */
const AnnouncementAcknowledgement = ({
  acknowledging,
  onAcknowledge,
  preview = false,
}: AnnouncementAcknowledgementProps) => {
  const checkboxId = useId();
  const [understood, setUnderstood] = useState(false);

  return (
    <div className="d-flex flex-column gap-4">
      <div className="announcement-modal-confirmation text-start">
        <div className="form-check form-check-custom form-check-solid gap-3">
          <input
            checked={understood}
            className="form-check-input"
            disabled={preview}
            id={checkboxId}
            type="checkbox"
            onChange={(event) => setUnderstood(event.target.checked)}
          />
          <label className="form-check-label text-gray-800 fw-semibold ms-0" htmlFor={checkboxId}>
            Li e compreendi este comunicado.
          </label>
        </div>
      </div>
      <button
        className="btn announcement-modal-confirm announcement-modal-action w-100 d-flex align-items-center justify-content-center gap-2"
        disabled={preview || !understood || acknowledging}
        type="button"
        onClick={onAcknowledge}
      >
        {acknowledging ? (
          <span aria-hidden="true" className="spinner-border spinner-border-sm" />
        ) : (
          <KTIcon className="fs-2" iconName="check" />
        )}
        Li e estou ciente
      </button>
    </div>
  );
};

export default AnnouncementAcknowledgement;
